import * as React from 'react';
import classNames from 'classnames';

import DatePicker from 'react-datepicker/es';
import 'react-datepicker/dist/react-datepicker.css';
import DialogContentText from '@material-ui/core/DialogContentText';
import Grid from '@material-ui/core/Grid';

interface Props {
  changeDateFrom: (id: number) => void;
  dateTo: Date;
  dateFrom: Date;
  dateError: string;
  changeDateTo: any;
}

function SubDateRange (props: Props) {
  
  const {
    changeDateFrom,
    changeDateTo,
    dateTo,
    dateError,
  } = props;

  const datePickersFieldSet = React.useMemo(() => classNames('sub-datepicker-fieldset', {
    'sub-error-fieldset': dateError,
  }), [dateError]);

  return(
    <React.Fragment>
      <br />
      <DialogContentText>
        {'Package Duration:'}
      </DialogContentText>
      <fieldset className={datePickersFieldSet}>
        <Grid
          container>
          <Grid
            item
            lg={5}>
            <fieldset
              // @ts-ignore
              onClick={changeDateFrom}
              className='sub-form-date-from sub-datepicker-fieldset'>
              <legend className=''>
                {'start'}
              </legend>
              <DatePicker
                showYearDropdown
                onChange={changeDateFrom}
                className='cursor-none'
                dateFormat='dd.MM.yyyy'
                placeholderText='date'
                selected={new Date()}
              />
            </fieldset>
          </Grid>
          <Grid
            item
            lg={1}
          />
          <Grid
            item
            lg={5}>
            <fieldset className='sub-datepicker-fieldset'>
              <legend className=''>
                {'finish'}
              </legend>
              <DatePicker
                showYearDropdown
                onChange={changeDateTo}
                className=''
                dateFormat='dd.MM.yyyy'
                placeholderText='date'
                selected={dateTo ? new Date(dateTo) : null}
              />
            </fieldset>
          </Grid>
        </Grid>
      </fieldset>

      <p className='color-red'>{dateError}</p>
    </React.Fragment>
  );
  
}

export default React.memo(SubDateRange);
